import AddTourContainer from './AddTourContainer';
import ChangeDayTypeContainer from './ChangeDayTypeContainer';
import EditTourContainer from './EditTourContainer';
import AddAssignmentContainer from './AddAssignmentContainer';
import EditAssignmentContainer from './EditAssignmentContainer';


const LiveScheduleUpdateForm = {
  AddTour: AddTourContainer,
  ChangeDayType: ChangeDayTypeContainer,
  EditTour: EditTourContainer,
  AddAssignment: AddAssignmentContainer,
  EditAssignment: EditAssignmentContainer
};

export default LiveScheduleUpdateForm;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/FormContainers/index.js